module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[18]261.7cd9779.woff2";